import React, { useState, useEffect } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import RevShareModal from "../../common/overrides/RevShareModal";
import FormRow from "../../common/forms/FormRow";
import SelectInput from "../../common/forms/SelectInput";
import { GetHeaders } from "../../../apis/common/ApiUtils";
import moment from "moment";

const CompOutAccrualCard = (props) => {
  const [year, setYear] = useState(NaN);
  const [week, setWeek] = useState(NaN);
  const [selectableYears, setSelectableYears] = useState([]);
  const [selectableWeeks, setSelectableWeeks] = useState([]);

  useEffect(() => {
    fetch("/api/compout/calculate/calculable", GetHeaders()).then((response) =>
      response.json().then((data) => setSelectableYears(data))
    );
  }, []);

  useEffect(() => {
    if (!isNaN(year)) setSelectableWeeks(selectableYears.find((i) => i.year === year).weeks);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, selectableYears]);

  const runCalculator = () => fetch(`/api/compout/calculate/${year}/${week}`, GetHeaders());

  return (
    <Card>
      <Card.Header>
        <h3>Comp Out Sync</h3>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm="8">
            <p>
              The Comp Out sync tool is used to manually trigger a sync between reported comp out stored in the data
              warehouse, and deduct the hours from available rev share in the Rev Share application.
            </p>
            <p>
              The sync tool can be run multiple times for the same week.{" "}
              <strong>
                If there is already comp out recorded for a given consultant for a given week the tool will skip the
                consultant for the week rether than recalculating.
              </strong>
            </p>
          </Col>
          <Col sm="4">
            <Form>
              <FormRow
                columns={[
                  <SelectInput
                    label="Year"
                    onChange={(event) => setYear(parseInt(event.target.value))}
                    options={selectableYears.map((i) => i.year)}
                  />,
                  <SelectInput
                    disabled={isNaN(year)}
                    label="Week"
                    onChange={(event) => setWeek(parseInt(event.target.value.split(" ")[0]))}
                    options={selectableWeeks.map(
                      (i) => `${i.number} (${moment(i.weekStart).format("M/D")} - ${moment(i.weekEnd).format("M/D")})`
                    )}
                  />,
                ]}
              />
              <RevShareModal
                buttonText="Run"
                buttonVariant="primary"
                modalSize="sm"
                selfClosing
                title="Confirm Run"
                yesButtonOnClick={() => runCalculator()}
                yesButtonText="Run"
              >
                <p>
                  Are you sure you want to run the accrual calculator for week {week}, {year}?
                </p>
              </RevShareModal>
            </Form>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CompOutAccrualCard;
